;;;(function($){
    var Common_Lazy_Img = {
        lists : function(obj){
            return $("img[data-src]");
        },
        load : function(data){
            var obj = data ? data : this.lists(),index=0,self = this;
            var initpic=function(){
                $(obj).each(function(){
                    var $this=$(this), height;
                    if(!$this.data("loaded")){
                        if($(window).scrollTop() <= $this.offset().top && $(window).scrollTop() + $(window).height() >= $this.offset().top){
                            height = self.getImgSize($this);
                            if(height){
                                $this
                                  .attr('width', '100%')
                                  .attr('height', height);
                            }
                            $this.attr("src",$this.attr("data-src"));
                            $this.data("loaded","true");
                            index++;
                        }
                    }
                });
            }
            var st  = function(){
                if(obj.length==index){
                    $(window).unbind("scroll",st);
                    $(window).unbind("resize",st);
                    return;
                }
                initpic();
            }

            $(window).bind("scroll",st);
            $(window).bind("resize",st);
            st();
        },
        getImgSize: function(img){
            var width, initWidth, height;
            initWidth = $(img).parent().width();
            if($(img).attr('width') && $(img).attr('height')){
                width = $(img).attr('width');
                height = $(img).attr('height');
                if(width < initWidth){
                    return null;
                }else{
                    return height * (initWidth / width);
                }
            }
            var tmp = new Image();
            tmp.onload = tmp.onerror = tmp.onabort = function(){
                this.onload = this.onerror = this.onabort = null;
                width = this.width;
                height = this.height;
                if(width && height){
                    return height * (initWidth / width);
                }else{
                    return null;
                }
                // this = null;
            };
        }
    };

    Common_Lazy_Img.load();

    function getQRcode (el, url){
        var w = el.outerWidth(),
          h = el.outerHeight();
        $(el).html('');
        $(el).qrcode({size: w, text: url});
    }

    function initEmoji(el){
        el.each(function (i, e) {
            if (twemoji) {
                twemoji.parse(e);
            }
        });
    }

    function checkIsLogin(){
        if($('body').attr('data-islogin') != 1){
            window.location.href = commonObj.data.loginUrl;
            return false;
        }
    }

    initEmoji($(".twemoji"));

    var initEvents = function(){
        $('.qr-code-tips a').on('mouseover', function(){
            if(!$('.qr-code').attr('loaded')){
                getQRcode($('.qr-code-tips .qr-code .qr'), location.origin + location.pathname + location.search);
                $('.qr-code').attr('loaded', 'true');
            }
            $('.qr-code').addClass('cur');
        });

        $('body').on('mouseover', function(e){
            var el = e.target || e.srcElement;
            el = $(el);
            if(!el.hasClass('qr-code-tips') && $('.qr-code-tips').has(el).length == 0){
                $('.qr-code').removeClass('cur');
            }
        })


        var url, tips, layer = $('.widget-download-layer');
        $('.download a').on('click', function(){
            url = $(this).attr('link');
            if($(this).hasClass('ios')){
                tips = '唱吧IOS版';
            }else{
                tips = '唱吧Android版';
            }
            layer.find('.title').html(tips);
            getQRcode(layer.find('.qr-wrapper a'), url);
            layer.find('.dl-to-pc a').attr('href', url);
            layer.show();
        })

        layer.find('.close').on('click', function(){
            $('.widget-download-layer').hide();
        })

        layer.on('click', function(e){
            var el = e.target || e.srcElement;
            el = $(el);
            if(el.hasClass('cover') || $('.cover').has(el).length == 0){
                $('.widget-download-layer').hide();
            }
        })

        var status, userid, workid, me;
        $('.focus', '.focus-follower').on('click', function(){
            status = $(this).attr('data-status');
            userid = $(this).attr('data-userid');
            me = this;
            if(status && status > 1){
                return;
            }
            checkIsLogin();
            $.getJSON('//changba.com/member/personcenter/oprUserRelation.php?status=0&wid=' + userid, function(data){
                if(data && data.message == 'no'){
                    $(me)
                      .removeAttr('data-status')
                      .find('em').html('已关注');
                }else if(data && data.message){
                    alert(data.message);
                }
            })
        })


        $('.fav','.work-info').on('click', function(){
            status = $(this).attr('data-status');
            workid = $(this).attr('data-workid');
            me = this;
            if(status && status != 0){
                return;
            }
            checkIsLogin();
            $.getJSON('//changba.com/now/collectWork.php?ac=collect&workid=' + workid, function(data){
                if(data && data.errorCode == 0){
                    $(me)
                      .removeAttr('data-status')
                      .find('em').html('已收藏');
                }else if(data && data.result){
                    alert(data.result);
                }
            })
        })

        // songid 歌词加载 删除这部分
        // if ($.inArray($('body').attr('data-songid'), ['1078515', '1078590', '1080105', '1080110', '1080209', '1081487', '1081499', '1090182', '1090189', '1090199', '1090200', '1090201', '1090204', '1090272', '1090325', '1090340', '1095947', '1096329']) >= 0) {
        //     var scriptTag = document.createElement('script');
        //     scriptTag.src = '//cdn-comp.changbaimg.com/js/game/dj/lrc/' + $('body').attr('data-songid') + '.js?ver=1.0.0';
        //     document.getElementsByTagName('head')[0].appendChild(scriptTag);
        // }
    }

    initEvents();

    var comment = function(){
        this.count = Number($('body').attr('data-count'));
        this.page = 1;
        this.size = 9;
        this.data = {};
        this.pageCount = Math.ceil(this.count / this.size);
        this.workid = $('body').attr('data-workid');
        this.container = $('.widget-comment .comment-list');
        this.url = '//changba.com/now/getComments.php?';
        this.controller = $('.controller a[data-action]');
        this.loadTag = true;
    };

    comment.prototype.init = function() {
        if(this.container.find('ul').length < 1){
            this.container.css('height', this.container.find('.no-comment-tips').outerHeight(true));
        }else{
            this.container.css('height', this.container.find('ul').outerHeight());
        }
        this.bindEvent();
    };

    comment.prototype.getCommentData = function(action) {
        var act = action, me = this, _data;
        if(act == 'prev' && me.page == 1){
            me.controller.filter('[data-action=prev]').css('visibility', 'hidden');
            return;
        }else if(act == 'next' && me.page == me.pageCount){
            me.controller.filter('[data-action=next]').css('visibility', 'hidden');
            return;
        }else{
            me.page = (act == 'next'? me.page + 1: me.page -1);
            me.controller.css('visibility', 'visible');
        }
        if(me.page == 1){
            me.controller.filter('[data-action=prev]').css('visibility', 'hidden');
        }
        if(me.page == me.pageCount){
            me.controller.filter('[data-action=next]').css('visibility', 'hidden');
        }
        if(me.data[me.page]){
            me.getCommentPainted(me.data[me.page]);
            return;
        }
        me.loadTag = false;
        $.getJSON(me.url + 'workid=' + me.workid + '&page=' + me.page + '&pageSize=' + me.size, function(data){
            if(data && data.errorcode == 0){
                me.getCommentPainted(data.result.comments);
                me.data[me.page] = data.result.comments;
                me.loadTag = true;
            }
        })
    };

    comment.prototype.getCommentPainted = function(data) {
        var _data = data, me = this, str = '', list = $('<ul class="clearfix" />');
        if(_data.length < 0){
            return;
        }
        for(var i = 0;i < _data.length;i ++){
            str += '<li class="items"><a class="poster" href="' + _data[i].user.homeurl + '" target="_blank"><img src="//cb.cdn.changbaimg.com/images/now/show/photo-default.png" data-src="' + (_data[i].user.headphoto? _data[i].user.headphoto.replace('.jpg', '_200_200.jpg'):'//cb.cdn.changbaimg.com/images/now/show/photo-default.png') +
              '"></a><div class="info"><span class="uinfo"><a class="uname twemoji" target="_blank" href="' + _data[i].user.homeurl + '">' + _data[i].user.nickname + '</a><em class="post-time">' + _data[i].time +
              '</em></span><span class="content twemoji">' + (/^\[Жs.*\]$/.test(_data[i].content)? ('<img src="http://a179img.changba.com/cache/test/s' + _data[i].content.substring('[Ж\/'.length, _data[i].content.indexOf(']')) + '" style="height: 50px;" />') :_data[i].content) + '</span></div></li>';
        }
        list
          .html(str)
          .css('display', 'none')
          .appendTo(me.container);

        me.container.css('height', list.outerHeight());
        str = null;
        list.siblings('ul').fadeOut('slow', function(){
            $(this).remove();
        });
        list.fadeIn('slow');
        // list.animate({'opacity': 1, 'left': '-458px'}, 'slow');
        // list.siblings('ul').animate({'opacity': '0'}, 'slow');

        // setTimeout(function(){
        //     list.removeAttr('style');
        //     list.siblings('ul').remove();
        // }, 800);

        $(".twemoji", list).each(function (i, e) {
            if (twemoji) {
                twemoji.parse(e);
            }
        });
        Common_Lazy_Img.load(list.find('img[data-src]'));
    };

    comment.prototype.bindEvent = function() {
        var me = this, action;
        me.controller.on('click', function(){
            if(!me.loadTag){
                return;
            }
            action = $(this).attr('data-action');
            me.getCommentData(action);
        });
    };

    var Comment = new comment();
    Comment.init();

})(jQuery);

(function ($) {

    function getQueryStrFn(name, url) {
        name = name.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]');
        if (!url) {
            url = window.location.href;
        }
        var _regexS = '[\\?&]' + name + '=([^&#]*)';
        var _regex = new RegExp(_regexS);
        var _results = _regex.exec(url);

        if (_results == null) {
            return '';
        } else {
            return decodeURIComponent(_results[1].replace(/\+/g, ' '));
        }
    };

    function MediaPlayer() {
        this.dom = null;
    }
    MediaPlayer.uiMode =
    {
        Full: "full",
        Mini: "mini",
        None: "none",
        Invisible: "invisible"
    }
    MediaPlayer.prototype = {
        //在指定ID的标签中创建MediaPlayer控件，大小由该标签决定
        CreateAt: function (id) {
            this.dom = document.createElement("object");
            this.dom.classid = "CLSID:6BF52A52-394A-11d3-B153-00C04F79FAA6";
            window.dom = this.dom;
            var container = document.getElementById(id);
            container.innerHTML = "";
            container.appendChild(this.dom);
            this._Init();
        },

        //绑定一个已存在的Object标签，该标签应该为一个MediaPlayer控件
        BindID: function (id) {
            this.dom = document.getElementById(id);
            this._Init();
        },
        _Init: function ()    //初始化，注册事件
        {
            var _this = this;
            if (!window.attachEvent) {
                this.dom.attachEvent = function (evn, fun) {
                }
            }
            this.dom.attachEvent("PlayStateChange",
              function (newState) { _this.onPlayStateChange(newState) });
            this.dom.attachEvent("Buffering", function (bStart) { _this.onBuffering(bStart) });
            this.dom.attachEvent("Error", function () { _this.onError(); });
            this.dom.attachEvent("PositionChange",
              function (oldPos, newPos) { _this.onPositionChange(oldPos, newPos); });
            this.dom.attachEvent("StatusChange", function (e) { _this.onStatusChange(e); })
        },
        onPlayStateChange: function (newState) {
            switch (newState) {
                case 1: //wmppsStopped
                    this.onStop();
                    break;
                case 2:  //wmppsPaused
                    this.onPaused();
                    break;
                case 3:  //wmppsPlaying
                    this.onPlay();
                    if (!this.hasLoaded) {
                        this.onReady();
                        this.hasLoaded = true;
                    }
                    break;
                case 4:  //wmppsScanForward
                    break;
                case 5:  //wmppsScanReverse
                    break;
                case 6:  //wmppsBuffering
                    this.onBuffering_SC();
                    break;
                case 7:  //wmppsWaiting
                    break;
                case 8:  //wmppsMediaEnded
                    this.onMediaEnded();
                    break;
                case 9:  //wmppsTransitioning
                    this.onTransitioning();
                    break;
                case 10:  //wmppsReady
                    break;
                case 11:  //wmppsReconnecting
                    break;
                case 12:  //wmppsLast
                    break;
                case 0:  //wmppsUndefined
                    break;
                default:
                    break;
            }
        },
        // 事件列表
        onStop: function () { },
        onPaused: function () { },
        onPlay: function () { },
        onBuffering_SC: function () { },
        onTransitioning: function () { },
        onMediaEnded: function () { },
        onError: function () { },
        onPositionChange: function (oldPos, newPos) { },
        onStatusChange: function () { },
        onBuffering: function (bStart) { },
        onReady: function(){},

        // 设置 暂时只做两个
        setMode: function (mode) { this.dom.uiMode = mode; },
        setVolume: function (v) { this.dom.settings.volume = v; },
        setAutoStart: function (start) { this.dom.settings.autoStart = start },

        // 各种属性
        getMediaName: function () {
            var media = this.dom.currentMedia;
            if (media) {
                return media.name;
            }
            return "";
        },
        getMediaDuration: function () {
            var media = this.dom.currentMedia;
            if (media) {
                return media.duration;
            }
            return "";
        },
        getMediaDurationString: function () {
            var media = this.dom.currentMedia;
            if (media) {
                return media.durationString;
            }
            return "";
        },
        getStatus: function () { return this.dom.status; },
        getPosition: function () { return this.dom.controls.currentPosition; },
        setPosition: function (value) { this.dom.controls.currentPosition = value; },
        getPositionString: function () { return this.dom.controls.currentPositionString; },
        getPlayState: function () { return this.dom.playState; },

        // 操作方法
        OpenUrl: function (URL) { this.dom.URL = URL; },
        Play: function () { this.dom.controls.play(); },
        Pause: function () { this.dom.controls.pause(); },
        Stop: function () { this.dom.controls.stop(); }
    };

    var mpl = new MediaPlayer();  //创建一个MediaPlayer

    var work = function () {
        this.processBtn = $('#process-btn');
        this.playedProcessBar = $('#work-played-bar');
        this.audio = document.getElementById('audio');
        this.hasAudio = !!(document.createElement('audio').canPlayType);
        this.lrcContainer = $('#lrc_container');
        this.LrcTimerId = 0;
    };

    work.prototype.init = function () {
        if (!this.hasAudio && this.audio) {
            var mpl = this.mpl = new MediaPlayer();
            mpl.CreateAt("audio_container"); //创建MediaPlayer
            mpl.setVolume(100);  //设置音量
            mpl.setMode(MediaPlayer.uiMode.Invisible);
            mpl.setAutoStart(true);
        }
        $(".twemoji").each(function (i, e) {
            if (twemoji) {
                twemoji.parse(e);
            }
        });
        //统计
        var _czc = this._czc = window._czc || [];
        _czc.push(["_setAccount", "1254909905"]);
        _czc.push(['_trackEvent', 'page', 'source', getQueryStrFn('source'), 0, 'body']);
        this.bindEvents();
    };

    work.prototype.bindEvents = function () {
        var self = this, currentTime = $('.time-counter').children().first();

        function registerDragEvent() {
            self.processBtn.on('mousedown', function (event) {
                self.processBtn.data('mousedown', true);
                event = event || window.event;
                self.processBtn.data('offsetX', (event.clientX || event.pageX) - self.playedProcessBar.width());
                //self.processBtn.data('offsetX', self.playedProcessBar.width());
            });

            $(document).on('mouseup', function () {
                self.processBtn.data('mousedown', false);
                self.processBtn.data('offsetX', undefined);
            })
              .on('mousemove', function (event) {
                  if (self.processBtn.data('mousedown')) {
                      event = event || window.event;
                      var clientX = event.clientX || event.pageX;
                      if (!self.processBtn.data('offsetX')) {
                          self.processBtn.data('offsetX', clientX);
                      }
                      var left = (clientX - self.processBtn.data('offsetX'));
                      if (left < 0) {
                          self.playedProcessBar.width(0);
                          currentTime.html('00:00');
                          if (self.audio) {
                              if (self.hasAudio) {
                                  self.audio.currentTime = 0;
                              }
                              else {
                                  self.mpl.seek(0);
                              }
                          }
                          else {
                              self.player.seek(0);
                          //    $.jPlayer.event.seeking
                          }
                          return false;
                      }
                      else if (left > 368 - 29) {
                          self.playedProcessBar.width(368 - 29);
                          currentTime.html($('.time-counter > .time-total').html());
                          if (self.audio) {
                              if (self.hasAudio) {
                                  self.audio.currentTime = self.audio.duration;
                              }
                              else {
                                  self.mpl.setPosition(self.mpl.dom.currentMedia.duration);
                              }
                          }
                          else {
                              self.player.seek(self.player.getPosition());
                          }
                          return false;
                      }
                      self.playedProcessBar.width(left);
                      if (self.audio) {
                          if (self.hasAudio) {
                              var curTime = left / 339.0 * self.audio.duration;
                          }
                          else {
                              var curTime = left / 339.0 * self.mpl.dom.currentMedia.duration;
                          }
                      }
                      else {
                          var curTime = left / 339.0 * self.player.getDuration;
                      }
                      self.showLrc(curTime * 1000);
                      min = Math.floor(curTime / 60), sec = Math.floor(curTime - min * 60);
                      if (min < 10) {
                          min = '0' + min;
                      }
                      if (sec < 10) {
                          sec = '0' + sec;
                      }
                      currentTime.html(min + ':' + sec);
                      if (self.audio) {
                          if (self.hasAudio) {
                              self.audio.currentTime = curTime;
                          }
                          else {
                              self.mpl.setPosition(curTime);
                          }
                      }
                      else {
                          self.player.seek(curTime);
                      }
                  }
                  return false;
              });
        }

        $('.time').on('click', function (e) {

            // 引入jplayer 插件会自动计算进度，所以不走以前那套逻辑了！！！
            if(this.classList.contains('jp-seek-bar')) {
                return false;
            }

            var target = e.target || e.srcElement;
            if (target.id === 'process-btn') {
                return false;
            }
            var org_left = $(this).offset().left,
              left = (e.pageX || e.clientX) - org_left - 29 / 2;
            if(left < 0){
                left = 0;
            }
            if(left > 339){
                left = 339;
            }
            self.playedProcessBar.width(left);
            if (self.audio) {
                if (self.hasAudio) {
                    var curTime = left / 339.0 * self.audio.duration;
                }
                else {
                    var curTime = left / 339.0 * self.mpl.dom.currentMedia.duration;
                }
            }
            else {
                var curTime = left / 339.0 * self.player.getDuration();
            }
            self.showLrc(curTime * 1000);
            min = Math.floor(curTime / 60), sec = Math.floor(curTime - min * 60);
            if (min < 10) {
                min = '0' + min;
            }
            if (sec < 10) {
                sec = '0' + sec;
            }
            currentTime.html(min + ':' + sec);
            if (self.audio) {
                if (self.hasAudio) {
                    self.audio.currentTime = curTime;
                }
                else {
                    self.mpl.setPosition(curTime);
                }
            }
            else {
                self.player.seek(curTime);
            }
            return false;
        });

        $('#play-btn').on('click', function () {
            if ($(this).hasClass('work-busy-btn')) {
                return;
            }
            var icon = $(this);
            if (icon.hasClass('play')) {
                icon.removeClass('play').addClass('pause');
                if (self.hasAudio) {
                    audio.play();
                }
                else {
                    self.mpl.Play();
                }
            }
            else {
                icon.removeClass('pause').addClass('play');
                if (self.hasAudio) {
                    audio.pause();
                }
                else {
                    self.mpl.Pause();
                }
            }
        });

        if (self.hasAudio && this.audio) {
            if (this.audio.duration > 0) {
                var min = Math.floor(self.audio.duration / 60), sec = Math.floor(self.audio.duration - min * 60);
                if (min < 10) {
                    min = '0' + min;
                }
                if (sec < 10) {
                    sec = '0' + sec;
                }
                $('.time-counter > .time-total').html(min + ':' + sec);
                self.unitWidth = (368 - 29) / self.audio.duration;
                registerDragEvent();
                $('#play-btn').removeClass('work-busy-btn');
            }
            else {
                var durationTimerId = window.setInterval(function () {
                    if (self.audio.duration > 0) {
                        //MB 遨游破浏览器，audio的事件全不支持，只能这种挫的方法写了
                        clearInterval(durationTimerId);
                        var min = Math.floor(self.audio.duration / 60), sec = Math.floor(self.audio.duration - min * 60);
                        if (min < 10) {
                            min = '0' + min;
                        }
                        if (sec < 10) {
                            sec = '0' + sec;
                        }
                        $('.time-counter > .time-total').html(min + ':' + sec);
                        self.unitWidth = (368 - 29) / self.audio.duration;
                        registerDragEvent();
                        $('#play-btn').removeClass('work-busy-btn');
                        if(!/safari/i.test(navigator.userAgent)){
                            self.audio.play();
                            $('#play-btn').removeClass('play').addClass('pause');
                        }
                    }
                }, 300);
                //self.audio.ondurationchange = function (e) {

                //};
            }
            self.audio.onplay = function (e) {
                $('#play-btn').removeClass('work-busy-btn');
                $('#play-btn').removeClass('play').addClass('pause');
            };

            var timeupdateId = window.setInterval(function () {
                var curTime = self.audio.currentTime,
                  min = Math.floor(curTime / 60), sec = Math.floor(curTime - min * 60);
                self.showLrc(curTime * 1000);
                if (min < 10) {
                    min = '0' + min;
                }
                if (sec < 10) {
                    sec = '0' + sec;
                }
                currentTime.html(min + ':' + sec);
                var width = self.unitWidth * curTime;
                if (width < 0) {
                    width = 0;
                }
                if (width > 368 - 29) {
                    width = 368 - 29;
                }
                self.playedProcessBar.width(self.unitWidth * curTime);
            }, 500);

            //self.audio.ontimeupdate = function (e) {
            //    var curTime = self.audio.currentTime,
            //        min = Math.floor(curTime / 60), sec = Math.floor(curTime - min * 60);
            //    if (min < 10) {
            //        min = '0' + min;
            //    }
            //    if (sec < 10) {
            //        sec = '0' + sec;
            //    }
            //    currentTime.html(min + ':' + sec);
            //    var width = self.unitWidth * curTime;
            //    if (width < 0) {
            //        width = 0;
            //    }
            //    if (width > 368 - 29) {
            //        width = 368 - 29;
            //    }
            //    self.playedProcessBar.width(self.unitWidth * curTime);
            //};
        }
        else if (this.audio) {
            var mpl = self.mpl, intervalId;
            mpl.onPlay = function () {
                var icon = $('#play-btn');
                icon.removeClass('play').addClass('pause');
                updatePlayer();
            };

            mpl.onStop = function () {
                var icon = $('#play-btn');
                icon.removeClass('pause').addClass('play');
                clearInterval(intervalId);
                clearInterval(self.LrcTimerId);
            };

            mpl.onPaused = function () {
                clearInterval(intervalId);
                clearInterval(self.LrcTimerId);
            };

            var updatePlayer = function () {
                intervalId = window.setInterval(function () {
                    var curTime = mpl.getPosition(),
                      min = Math.floor(curTime / 60), sec = Math.floor(curTime - min * 60);
                    self.showLrc(curTime * 1000);
                    if (min < 10) {
                        min = '0' + min;
                    }
                    if (sec < 10) {
                        sec = '0' + sec;
                    }
                    currentTime.html(min + ':' + sec);
                    var width = self.unitWidth * curTime;
                    if (width < 0) {
                        width = 0;
                    }
                    if (width > 368 - 29) {
                        width = 368 - 29;
                    }
                    self.playedProcessBar.width(self.unitWidth * curTime);
                }, 1000);
            };

            mpl.onReady = function (e) {
                var min = Math.floor(self.mpl.dom.currentMedia.duration / 60), sec = Math.floor(self.mpl.dom.currentMedia.duration - min * 60);
                if (min < 10) {
                    min = '0' + min;
                }
                if (sec < 10) {
                    sec = '0' + sec;
                }
                $('.time-counter > .time-total').html().html(min + ':' + sec);
                self.unitWidth = (368 - 29) / self.mpl.dom.currentMedia.duration;
                registerDragEvent();
                $('#play-btn').removeClass('work-busy-btn');
            };

            mpl.OpenUrl(self.audio.src);  //打开音乐
        }
        //video
        else if ($('#pad_video').length) {
            var base64DecodeChars = new Array(-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 62, -1, -1, -1, 63, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, -1, -1, -1, -1, -1, -1, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, -1, -1, -1, -1, -1, -1, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, -1, -1, -1, -1, -1);
            /**
             * base64解码
             * @param {Object} str
             */
            function base64decode(str) {
                var c1, c2, c3, c4;
                var i, len, out;
                len = str.length;
                i = 0;
                out = "";
                while (i < len) {
                    /* c1 */
                    do {
                        c1 = base64DecodeChars[str.charCodeAt(i++) & 0xff];
                    }
                    while (i < len && c1 == -1);
                    if (c1 == -1)
                        break;
                    /* c2 */
                    do {
                        c2 = base64DecodeChars[str.charCodeAt(i++) & 0xff];
                    }
                    while (i < len && c2 == -1);
                    if (c2 == -1)
                        break;
                    out += String.fromCharCode((c1 << 2) | ((c2 & 0x30) >> 4));
                    /* c3 */
                    do {
                        c3 = str.charCodeAt(i++) & 0xff;
                        if (c3 == 61)
                            return out;
                        c3 = base64DecodeChars[c3];
                    }
                    while (i < len && c3 == -1);
                    if (c3 == -1)
                        break;
                    out += String.fromCharCode(((c2 & 0XF) << 4) | ((c3 & 0x3C) >> 2));
                    /* c4 */
                    do {
                        c4 = str.charCodeAt(i++) & 0xff;
                        if (c4 == 61)
                            return out;
                        c4 = base64DecodeChars[c4];
                    }
                    while (i < len && c4 == -1);
                    if (c4 == -1)
                        break;
                    out += String.fromCharCode(((c3 & 0x03) << 6) | c4);
                }
                return out;
            }

            $('#pad_video').attr('src', base64decode(jplayer.video_url));
        }
        else if($('#play-video-btn').length){
            var playVideoBtn = $('#play-video-btn'), intervalId, hasLoaded;
            var base64DecodeChars = new Array(-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 62, -1, -1, -1, 63, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, -1, -1, -1, -1, -1, -1, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, -1, -1, -1, -1, -1, -1, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, -1, -1, -1, -1, -1);
            /**
             * base64解码
             * @param {Object} str
             */
            function base64decode(str) {
                var c1, c2, c3, c4;
                var i, len, out;
                len = str.length;
                i = 0;
                out = "";
                while (i < len) {
                    /* c1 */
                    do {
                        c1 = base64DecodeChars[str.charCodeAt(i++) & 0xff];
                    }
                    while (i < len && c1 == -1);
                    if (c1 == -1)
                        break;
                    /* c2 */
                    do {
                        c2 = base64DecodeChars[str.charCodeAt(i++) & 0xff];
                    }
                    while (i < len && c2 == -1);
                    if (c2 == -1)
                        break;
                    out += String.fromCharCode((c1 << 2) | ((c2 & 0x30) >> 4));
                    /* c3 */
                    do {
                        c3 = str.charCodeAt(i++) & 0xff;
                        if (c3 == 61)
                            return out;
                        c3 = base64DecodeChars[c3];
                    }
                    while (i < len && c3 == -1);
                    if (c3 == -1)
                        break;
                    out += String.fromCharCode(((c2 & 0XF) << 4) | ((c3 & 0x3C) >> 2));
                    /* c4 */
                    do {
                        c4 = str.charCodeAt(i++) & 0xff;
                        if (c4 == 61)
                            return out;
                        c4 = base64DecodeChars[c4];
                    }
                    while (i < len && c4 == -1);
                    if (c4 == -1)
                        break;
                    out += String.fromCharCode(((c3 & 0x03) << 6) | c4);
                }
                return out;
            }

            var jPlayerMedia = {
                m4v: base64decode(jplayer.video_url),
                flv: base64decode(jplayer.video_url),
                poster: jplayer.video_poster
            }

            var jp = $("#jquery_jplayer_1"), jpData = jp.data('jPlayer');

            var player = self.player = jp.jPlayer({
                ready: function () {
                    $(this).jPlayer("setMedia", jPlayerMedia);
                    console.log('jplayer ready');
                },
                swfPath: "//cbshowhot.cdn.changbaimg.com/-/5d3a476e21c72b42/jquery.jplayer.swf",
                solution: "html, flash",
                supplied: "m4v, flv",
                size: {
                    width: 478,
                    height: 478,
                    cssClass: "jp-video-360p"
                },
                useStateClassSkin: true,
                cssSelector: {
                    play: ".jp-play",
                    pause: ".jp-pause",
                    seekBar: ".jp-seek-bar",
                    seekBarBtn: '.jp-seek-bar-btn', // 自己在jplayer源码新添的
                    playBar: ".jp-work-played-bar",
                    currentTime: ".jp-current-time",
                    duration: ".jp-duration "
                },
                // 播放
                play: function(event) {
                    if (commonObj.data.newuserRe) {
                        $(this).jPlayer("pause");
                        alert('作品正在审核中，暂无法查看');
                        return;
                    }
                    console.log('jplayer play');
                    $(this).jPlayer("play");
                    $(this).jPlayer("pauseOthers");
                    $('#play-video-btn').addClass('pause');

                },
                // 暂停
                pause: function() {
                    console.log('jplayer pause');
                    $('#play-video-btn').addClass('play');
                    $('#play-video-btn').removeClass('pause');

                },
                // 播放完毕后的回调函数
                ended: function() {
                    $(this).jPlayer("setMedia", jPlayerMedia);
                }
            });

        }
        $('.content').each(function(){
            var text = $.trim($(this).text());
            if(/^\[Жs.*\]$/.test(text)){
                $(this).html('<img style="height: 50px;" src="http://a179img.changba.com/cache/test/s'+ text.substring('[Ж\/'.length, text.indexOf(']')) +'" alt="" />');
            }
        });
    };

    work.prototype.showLrc = function (time) {
        if (!window.song_lrc) {
            return false;
        }
        //return;
        var self = this, destItem;
        self.lrc = song_lrc;
        for (var l = self.lrc.length, i = 0; i < l; i++) {
            var item = self.lrc[i];
            if (item.start <= time && item.start + item.duration >= time) {
                destItem = item;
                break;
            }
        }
        if (destItem && destItem.text !== self.lrcContainer.text()) {
            clearTimeout(self.LrcTimerId);
            self.lrcContainer.text(destItem.text);
            self.LrcTimerId = setTimeout(function () {
                self.lrcContainer.text('');
            }, destItem.start - time + destItem.duration);
        }
    };

    (new work()).init();
})(jQuery);
